export default __webpack_public_path__ + "static/media/money-send.1b9ed1af.svg";